import SoundRecordingAssetAuditTable from "../MusicAssetAuditComponents/SoundRecordingAssetsAudits";

const MusicVideosRoute = () => {
  return (
    <>
      <SoundRecordingAssetAuditTable />
    </>
  );
};

export default MusicVideosRoute;
